import React, { useState } from 'react';
import GuestInfoView from './views/GuestInfoView';
import { useGuestInfo } from './hooks/GuestInfo.hook';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

const GuestInfoController = () => {
  const {
    loading,
    error,
    handleSubmit,
    selectedCountry,
    showDropdown,
    dropdownRef,
    countries,
    handleCountrySelect,
    toggleDropdown,
    showModal,
    openModal,
    closeModal,
  } = useGuestInfo();

  const languageData = useSelector(state => state.lenguage?.lang);
  const [userEmail, setUserEmail] = useState('');

  const initialValues = {
    name: '',
    email: '',
    phone: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().min(6, 'Minimum 6 characters').required('Required'),
  });

  const onGuestInfo = async values => {
    console.log(' DATOS GUARDADOS EN GUEST INFO:');
    console.log(' Nombre:', values.name);
    console.log(' Email:', values.email);
    console.log(' Teléfono:', values.phone);
    console.log(' País seleccionado:', selectedCountry);

    // Guardar el email para mostrarlo en el modal
    setUserEmail(values.email);

    // Abrir el modal
    openModal();
  };

  return (
    <GuestInfoView
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={values => handleSubmit(values, onGuestInfo)}
      loading={loading}
      error={error}
      languageData={languageData}
      selectedCountry={selectedCountry}
      showDropdown={showDropdown}
      dropdownRef={dropdownRef}
      countries={countries}
      handleCountrySelect={handleCountrySelect}
      toggleDropdown={toggleDropdown}
      showModal={showModal}
      openModal={openModal}
      closeModal={closeModal}
      userEmail={userEmail}
    />
  );
};

export default GuestInfoController;
